import React from 'react';

import './LandingElectricSection.scss';

export default function LandingElectricSection({
  title,
  text,
  ctaLabel,
  onCtaClick,
  imageSrc,
  imageAlt = ''
}) {
  return (
    <section className="dark landing-electric">
      <div className="inner">
        <div className="landing-electric__layout">
          <div className="landing-electric__content">
            <h2>{title}</h2>
            <p>{text}</p>
            
            <button
              type="button"
              onClick={onCtaClick}
              className="btn landing-cta-4 landing-electric__cta"
              aria-label={ctaLabel}
            >
              <span className="text">{ctaLabel}</span>
            </button>
   
          </div>

          <div className="landing-electric__media">
            <img
              src={imageSrc}
              alt={imageAlt}
              className="landing-electric__image"
            />
          </div>
        </div>
      </div>
    </section>
  );
}